export default __webpack_public_path__ + "static/media/cz.52ba1c8f.svg";